import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { isNil } from 'lodash-es';
import { combineLatest, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { LoadingGuard } from '@schir-int-client/ngrx-helpers';
import {
	addZaehlblattAktionenAction,
	deleteZaehlblattAktionAction,
	loadZaehlblattAction,
	VerfahrenLinkRel,
	VerfahrenResource,
	VerfahrenRootState,
	verfahrenSingleSelector,
	ZaehlblattAktionen,
	ZaehlblattEntryListResource,
	ZaehlblattEntryResource,
	zaehlblattSelector,
} from '@schir-int-client/verfahren-shared';

@Injectable({ providedIn: 'root' })
export class ZaehlblattFacade {
	zaehlblatt: Observable<ZaehlblattEntryListResource> = this.getZaehlblatt();

	private lastLoadedZaehlblatt: ZaehlblattEntryListResource;

	private loading = new LoadingGuard(this.store);

	constructor(private store: Store<VerfahrenRootState>) {
		this.zaehlblatt.subscribe(zaehlblatt => (this.lastLoadedZaehlblatt = zaehlblatt));
	}

	private getZaehlblatt(): Observable<ZaehlblattEntryListResource> {
		return combineLatest([this.store.select(verfahrenSingleSelector), this.store.select(zaehlblattSelector)]).pipe(
			filter(([verfahren]) => !isNil(verfahren?._links[VerfahrenLinkRel.ZAEHLBLATT])),
			filter(
				([verfahren, zaehlblatt]) =>
					!this.loading.mustLoadFirst(
						zaehlblatt,
						() => loadZaehlblattAction({ verfahren }),
						verfahren._links[VerfahrenLinkRel.ZAEHLBLATT].href
					)
			),
			map(([, zaehlblatt]) => zaehlblatt.resource)
		);
	}

	addZaehlblattAktionen(values: ZaehlblattAktionen, verfahren: VerfahrenResource): void {
		if (
			this.lastLoadedZaehlblatt?._links &&
			this.lastLoadedZaehlblatt._links.self.href === verfahren._links[VerfahrenLinkRel.ZAEHLBLATT]?.href
		) {
			this.store.dispatch(addZaehlblattAktionenAction({ values, zaehlblatt: this.lastLoadedZaehlblatt }));
		}
	}

	delete(entry: ZaehlblattEntryResource) {
		this.store.dispatch(deleteZaehlblattAktionAction({ entry }));
	}
}
